<template>
	<div>
		<img
			v-if="isSpanBySpan"
			src="./loads--isSpanBySpan.png"
			alt="Loads Distributed Span By Span"
		/>
		<img v-else src="./loads--isntSpanBySpan.png" alt="Loads Distributed" />
	</div>
</template>

<script>
export default {
	props: {
		isSpanBySpan: {
			type: Boolean,
		},
	},
};
</script>
